export default {
  MobileHeaderControl__BUTTON_GROUP_ARIA_NEXT: "Next",
  MobileHeaderControl__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  MobileHeaderControl__CARDMEMBER: "Rapid Rewards Cardmember",
  MobileHeaderControl__CREDIT_CARD__EMPLOYEE: "Rapid Rewards Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__LEGACY_CHASE: "Rapid Rewards Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__LEGACY_CLASSIC: "Rapid Rewards Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__LEGACY_CLASSIC_CARD: "Rapid Rewards Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__LEGACY_PLUS: "Rapid Rewards Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PERFORMANCE: "Performance Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PERFORMANCE_BUSINESS: "Performance Business Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PLUS: "Plus Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PLUS_BUSINESS: "Plus Business Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PREMIER: "Premier Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PREMIER_BUSINESS: "Premier Business Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PRIORITY: "Priority Credit Cardmember",
  MobileHeaderControl__CREDIT_CARD__PRIORITY_BUSINESS: "Priority Business Credit Cardmember",
  MobileHeaderControl__GREETING: (option) => `Hi, ${option.name}`,
  MobileHeaderControl__LOG_IN_ENROLL: "Log in / Enroll",
  MobileHeaderControl__LOG_IN_OR_ENROLL: "Log in or enroll",
  MobileHeaderControl__LOG_OUT: "Log out",
  MobileHeaderControl__LOGIN_PURPOSE: "to manage your trips and account activity.",
  MobileHeaderControl__MY_ACCOUNT_LINK_TEXT: "View Account",
  MobileHeaderControl__POINTS_ABBREVIATED: "PTS",
  MobileHeaderControl__TIER_A_LIST: "A-List",
  MobileHeaderControl__TIER_A_LIST_PREFERRED: "A-List Preferred",
  MobileHeaderControl__TIER_PENDING: "Status Pending",
};
